export default __webpack_public_path__ + "static/media/magia.89d61ffc.png";